import React, { useState } from "react";
import { Chip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { SCREENING_QUESTION_TEMPLATES } from "../../constants/screeningQuestionTemplates";
import "./ScreeningQuestionChips.css";

const ScreeningQuestionChips = ({
  existingQuestions = [],
  onAddQuestion,
  onAddCustomQuestion,
  jobPostingsId,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const isTemplateAdded = (template) => {
    if (template.id === "custom") return false;
    if (template.isMultiAdd) return false;
    const byTemplateId = existingQuestions.some(
      (q) => q.templateId === template.id,
    );
    if (byTemplateId) return true;
    const escaped = template.questionTemplate
      .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
      .replace(/\\\[.*?\\\]/g, ".+");
    const regex = new RegExp("^" + escaped + "$", "i");
    return existingQuestions.some(
      (q) => q.question && !q.templateId && regex.test(q.question),
    );
  };

  const getAddedCount = (template) => {
    if (!template.isMultiAdd) return 0;
    const byId = existingQuestions.filter(
      (q) => q.templateId === template.id,
    ).length;
    const escaped = template.questionTemplate
      .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
      .replace(/\\\[.*?\\\]/g, ".+");
    const regex = new RegExp("^" + escaped + "$", "i");
    const byText = existingQuestions.filter(
      (q) => q.question && !q.templateId && regex.test(q.question),
    ).length;
    return byId + byText;
  };

  const sortedTemplates = [...SCREENING_QUESTION_TEMPLATES].sort((a, b) => {
    if (a.id === "custom") return 1;
    if (b.id === "custom") return -1;
    return a.category.localeCompare(b.category);
  });

  const handleChipClick = (template) => {
    if (template.id === "custom") {
      onAddCustomQuestion();
      return;
    }

    if (isTemplateAdded(template)) return;

    const prefilled = {};
    if (template.placeholders.length > 0) {
      template.placeholders.forEach((p) => {
        prefilled[p.key] = "";
      });
    }

    let questionText = template.questionTemplate;

    const questionObj = {
      question: questionText,
      type: template.type,
      subQuestion: template.subQuestion ? [...template.subQuestion] : [""],
      multiOptions: [""],
      text: "",
      numeric: "",
      status: "1",
      jobPostingsId: jobPostingsId,
      id: null,
      isEdit: true,
      templateId: template.id,
      placeholderValues: prefilled,
      isTemplateQuestion: true,
    };

    onAddQuestion(questionObj);
  };

  return (
    <div className="sq-chips-wrapper">
      <div
        className={`sq-chips-toggle ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <KeyboardArrowDownIcon />
        Add screening questions
      </div>

      {isOpen && (
        <div className="sq-chips-container">
          {sortedTemplates.map((template) => {
            const added = isTemplateAdded(template);
            const isCustom = template.id === "custom";
            const multiCount = getAddedCount(template);

            return (
              <Chip
                key={template.id}
                className={`sq-chip${added ? " added" : ""}${multiCount > 0 ? " added" : ""}${isCustom ? " custom-chip" : ""}`}
                icon={
                  added ? (
                    <CheckIcon style={{ fontSize: 16 }} />
                  ) : isCustom ? (
                    <EditIcon style={{ fontSize: 16 }} />
                  ) : (
                    <AddIcon style={{ fontSize: 16 }} />
                  )
                }
                label={
                  multiCount > 0
                    ? `${template.category} (${multiCount})`
                    : template.category
                }
                onClick={() => handleChipClick(template)}
                variant="outlined"
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ScreeningQuestionChips;
